import React from 'react';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { compose } from 'ramda';
import styleFile from './DestinationAvailBtn.js';
import { Button } from '@synergycms_core/components/generic';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';

const DestinationAvailBtn = (props) => {
    const { hotelCity, goBack, deviceType, id } = props.config;

    return (
        <Button
            id={id || undefined}
            onClick={goBack}
            innerStyle={[deviceType === 'DESK' ? 'searchOptionsHotelLink' : '', 'mainColor']}
            richText={{
                text: deviceType === 'MOBIL' || deviceType === 'TABLET' ? '_%Hoteles en {ubicacion}%_' : '_%Ver hoteles en {ubicacion}%_',
                innerStyle: ['roboto13Black', 'mainColor'],
                translate: true,
                withVars: {ubicacion: hotelCity.get('name')},
                /*icon: {
                  unicodeContent: 'e088',
                  innerStyle: ['size20', 'marginRight5', 'mainColorSvg'],
                }*/
            }}/>
    );
};



export default compose(
    PropertyManager([
        'hotelCity',
        'goBack',
        'deviceType',
        'id',
    ]),
    withThemeJSS({styleFile, link: true}),
)(DestinationAvailBtn);